export const driverFieldConfiguration = [
  {
    name: "firstName",
    label: "First Name",
    type: "text",
    validation: {
      required: "First Name is required",
      minLength: { value: 2, message: "Minimum length is 2 characters" },
      maxLength: { value: 50, message: "Maximum length is 50 characters" },
    },
  },
  {
    name: "lastName",
    label: "Last Name",
    type: "text",
    validation: {
      required: "Last Name is required",
      minLength: { value: 2, message: "Minimum length is 2 characters" },
      maxLength: { value: 50, message: "Maximum length is 50 characters" },
    },
  },
  {
    name: "phoneNumber",
    label: "Phone Number",
    type: "text",
    validation: {
      required: "Phone number is required",
      pattern: {
        value: /^\d+$/,
        message: "Phone number must contain only digits",
      },
    },
  },
];

export const driverInitialValues = {
  firstName: "",
  lastName: "",
  phoneNumber: "",
};
